import React from "react";
import styled from '@emotion/styled';
import ImageTitle from "../components/ImageTitle";
import TeamImage from "../assets/images/CNC-Team.png";
import { IoIosMail } from "react-icons/io";
import { motion } from "framer-motion";

const Transparencia = () => {

    const AboutDiv = styled.div`
    background:rgb(255, 255, 255);
    padding-bottom: 50px;
    width: 100%;
`;




return (
<AboutDiv>
  <ImageTitle title="TRANSPARENCIA" subtitle="Conoce nuestros procesos y avances" image={TeamImage} />

<iframe title="Portal de Transparencia" width="1000" height="600" src="https://app.powerbi.com/view?r=eyJrIjoiNjBhY2JjN2ItMWUxMi00MmQwLWIzM2ItZmZjMGM1MGU0ZjU1IiwidCI6IjU0ZjUxOTYzLTQ2Y2ItNDBiYi1hODAwLWQ0YjM1ZDJjODUyNiIsImMiOjR9" frameborder="0" allowFullScreen="true"></iframe>

          </AboutDiv>
        );
      };
      
      export default Transparencia;